/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1AuthTokenResponse
 */
export interface V1AuthTokenResponse {
    /**
     * Updated JWT token with 10 years TTL
     */
    token: string
}

/**
 * Check if a given object implements the V1AuthTokenResponse interface.
 */
export function instanceOfV1AuthTokenResponse(
    value: object
): value is V1AuthTokenResponse {
    if (!('token' in value) || value['token'] === undefined) return false
    return true
}

export function V1AuthTokenResponseFromJSON(json: any): V1AuthTokenResponse {
    return V1AuthTokenResponseFromJSONTyped(json, false)
}

export function V1AuthTokenResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthTokenResponse {
    if (json == null) {
        return json
    }
    return {
        token: json['token']
    }
}

export function V1AuthTokenResponseToJSON(json: any): V1AuthTokenResponse {
    return V1AuthTokenResponseToJSONTyped(json, false)
}

export function V1AuthTokenResponseToJSONTyped(
    value?: V1AuthTokenResponse | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        token: value['token']
    }
}
